// ============================================================
// Scoring Constants — Standard 21 (Cancellation)
// ============================================================

/** Points for a bag through the hole */
export const POINTS_IN = 3;

/** Points for a bag on the board */
export const POINTS_ON = 1;

/** Bags per player per round */
export const BAGS_PER_PLAYER = 4;

/** Target score for Standard 21 */
export const WIN_SCORE = 21;

/** Score 11 is impossible in cornhole */
export const IMPOSSIBLE_SCORES = [11] as const;

/** Score values available in Advanced PPR grid */
export const ADVANCED_PPR_GRID = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12] as const;

/** Scores in Advanced PPR that require clarification (ambiguous IN/ON combos) */
export const AMBIGUOUS_SCORES: Record<number, string[]> = {
  3: ['1 IN', '3 ON'],
  4: ['1 IN + 1 ON', '4 ON'],
  6: ['1 IN + 3 ON', '2 IN'],
};

/** Default warm-up duration in seconds */
export const DEFAULT_WARMUP_DURATION = 300; // 5 minutes

/** Score entry overlay auto-dismiss timeout in milliseconds */
export const SCORE_ENTRY_TIMEOUT_MS = 10_000;

/** Default skins rounds to win */
export const DEFAULT_SKINS_ROUNDS_TO_WIN = 7;

/** Default skins points per round win */
export const DEFAULT_SKINS_POINTS_PER_WIN = 25;

// ============================================================
// ACO Brand Config Default
// ============================================================

import type { BrandConfig } from '../types/index.js';

export const ACO_BRAND_CONFIG: BrandConfig = {
  id: 'aco',
  name: 'American Cornhole Organization',
  shortName: 'ACO',
  colors: {
    primary: '#1a3a6b',
    secondary: '#e8a020',
    scoreboard: {
      left: '#1a3a6b',
      right: '#c0392b',
    },
    background: '#0f1923',
    text: '#ffffff',
  },
  logos: {
    full: '/logos/aco-full.svg',
    icon: '/logos/aco-icon.svg',
    wordmark: '/logos/aco-wordmark.svg',
  },
  terms: {
    tournament: 'Tournament',
    division: 'Division',
    round: 'Round',
    court: 'Court',
  },
  defaults: {
    warmUpDuration: 300,
    scoringMode: 'simple',
    gameType: 'standard21',
    skinsRoundsToWin: 7,
    skinsPointsPerWin: 25,
    roundCap: 0,
  },
  features: {
    simpleScoring: true,
    intermediatePPR: true,
    advancedPPR: true,
    skinsGame: true,
    standaloneMode: true,
    spectatorView: false,
    photoBoothIntegration: false,
  },
};

export const BULLSEYE_BRAND_CONFIG: BrandConfig = {
  id: 'bullseye',
  name: 'Bullseye Cornhole',
  shortName: 'Bullseye',
  colors: {
    primary: '#b30000',
    secondary: '#f5a623',
    scoreboard: {
      left: '#b30000',
      right: '#1a1a2e',
    },
    background: '#0f0f0f',
    text: '#ffffff',
  },
  logos: {
    full: '/logos/bullseye-full.svg',
    icon: '/logos/bullseye-icon.svg',
    wordmark: '/logos/bullseye-wordmark.svg',
  },
  terms: {
    tournament: 'Tournament',
    division: 'Division',
    round: 'Round',
    court: 'Court',
  },
  defaults: {
    warmUpDuration: 300,
    scoringMode: 'simple',
    gameType: 'standard21',
    skinsRoundsToWin: 7,
    skinsPointsPerWin: 25,
    roundCap: 0,
  },
  features: {
    simpleScoring: true,
    intermediatePPR: true,
    advancedPPR: false,
    skinsGame: false,
    standaloneMode: true,
    spectatorView: false,
    photoBoothIntegration: false,
  },
};
